import React from 'react';
import PropTypes from 'prop-types';
import {Button, Image} from '@learningblocks/storybook-components';
import LidActionVector from '@learningblocks/exp-constants/lib/Images/mc_lid_action_vector.svg';
import {MCStateContext} from '../../..';
import {useTranslation} from 'react-i18next';

import './style.scss';

const TRANSLATION_KEY = {
  CLOSE: 'CloseLid.string',
  OPEN: 'OpenLid.string',
};

/**
 * LidActionButtons:
 *    Renders open lid and close lid button depending on lid status
 */
export function LidActionButtons(props) {
  const {isLidOpen} = React.useContext(MCStateContext);

  const {t} = useTranslation();

  const renderCloseLid = () => (
    <div className='mc_lid_action'>
      <Button
        className='mc_lid_action_button'
        onClick={props.onClick}
        style={{
          background: (props.balanced)?"#faac48":"transparent",
          color: (props.balanced)?"#003e6b":"white",
          border: (props.balanced)?"none":"1px solid white"
        }}
      >
        {t(TRANSLATION_KEY.CLOSE)}
      </Button>
      <Image className='mc_lid_action_vector' src={LidActionVector} />
    </div>
  );

  const renderOpenLid = () => (
    <div className='mc_lid_action --mc_closeLid'>
      <Button
        className='mc_lid_action_button --mc_closeLid_button'
        onClick={props.onClick}>
        {t(TRANSLATION_KEY.OPEN)}
      </Button>
      <Image
        className='mc_lid_action_vector --mc_closedLid_vector'
        src={LidActionVector}
      />
    </div>
  );

  return isLidOpen ? renderCloseLid() : renderOpenLid();
}

LidActionButtons.propTypes = {
  /**
   * callback for triggering lid toggle action
   */
  onClick: PropTypes.func,
};

LidActionButtons.defaultProps = {};
